// eslint-disable-next-line import/prefer-default-export
export const AGENT_ID_QUERY_KEY = 'agent'
